import generalModule from "../../../../utilities/GeneralModule";
import { ComponentTypes } from "../../config/config";

export class AdvancedSearchHelper {
    static validComponentTypes = [ComponentTypes.SharePointDocuments, ComponentTypes.SharePointFolders];
    static invalidPlatformTypes = generalModule.getIsOfficeJSAvailable()
        ? [Office.PlatformType.Android, Office.PlatformType.iOS]
        : [];

    static canView(componentType: string) {
        return generalModule.getIsOfficeJSAvailable()
            && AdvancedSearchHelper.validComponentTypes.some(cpt => cpt === componentType)
            && !AdvancedSearchHelper.invalidPlatformTypes.some(pt => pt === Office.context.diagnostics.platform)
    }
}